var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3C11.2611 3 13.2462 5.13795 14.2324 6.625C14.8001 7.48096 14.7983 8.5693 14.2256 9.42188C13.2371 10.8932 11.2537 13 8 13C4.74643 12.9999 2.76285 10.8932 1.77441 9.42188C1.20189 8.56936 1.20005 7.48088 1.76758 6.625C2.75371 5.13799 4.73896 3.00014 8 3ZM8 5C6.3433 5.00018 5 6.34326 5 8C5 9.65674 6.3433 10.9998 8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5Z",
    fill: "#002A69"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 1.5,
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.332cb6c36f57a5dbb6dfd21870d8d489.svg";
export { ForwardRef as ReactComponent };